export default __webpack_public_path__ + "static/media/Arch.14dc816e.svg";